import { FC, useMemo } from 'react'
import styles from 'components/features/coaching/advisorPublicPage/AdvisorReview/AdvisorReview.styl'
import { StarsRow } from 'components/features/coaching/advisorPublicPage/StarsRow/StarsRow'
import moment from 'moment'

type AdvisorReviewProps = {
  rating: number
  date: string
  name: string
  from?: string
}

export const AdvisorReview: FC<AdvisorReviewProps> = (props) => {
  const { rating, date, name, from, children } = props

  const dateChild = useMemo(() => {
    const weekAgo = moment().subtract(1, 'week')
    if (weekAgo.isAfter(date)) {
      return moment(date).format('MMM D, YYYY')
    }
    return `${ moment.duration(moment().diff(date)).humanize() } ago`
  }, [date])

  return (
    <div className={ styles.advisorReview }>
      <div className={ styles.headline }>
        <div className={ styles.rating }>
          <StarsRow rating={ rating } />
        </div>
        <div className={ styles.date }>
          { dateChild }
        </div>
      </div>
      <div className={ styles.text }>
        { children }
      </div>
      <div className={ styles.name }>
        { name }
      </div>
      { from && (
        <div className={ styles.from }>
          from { from }
        </div>
      )}
    </div>
  )
}
